import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Icon } from '@material-ui/core';
import { BackdropCircular } from 'components';
import './learnMoreStyles.css';
import { getCmsBlockByIdentifierApi } from 'api';
import { useParams, useHistory } from 'react-router-dom';


const LearnMorePage = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();

  const { cmsBlock: {content = ''}, loadingCmsBlock } = useSelector((state) => state.cms_blocks);

  useEffect(() => {
    getCmsBlockByIdentifierApi({dispatch, identifier: params.identifier});
  }, [params]);

  return (
    <div className="flex-grow min-h-full scroll-y pb-25">
      <div
        className="inline-flex items-center text-primary mx-10 mt-10 cursor-pointer"
        onClick={() => history.push('/affiliates')}
      >
        <Icon
          className="mr-2"
        >
          assignment_return
        </Icon>
        Go to brands
      </div>
      <Card
        className="m-10 p-8"
        elevation={25}
      >
        <div dangerouslySetInnerHTML={{__html: content}} />
      </Card>
      <BackdropCircular loading={loadingCmsBlock} />
    </div>
  );
};

export default LearnMorePage;
